import * as React from 'react';
import { createStyles, makeStyles } from '../styles';
var dotRadius = 3;
var radius = 8;
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: function (props) {
            // Unchecked enabled appearance by default.
            var backgroundColor = theme.palette.background.default;
            var borderColor = theme.palette.border.dark;
            var dotColor = backgroundColor;
            var axDotVisible = false;
            if (props.disabled) {
                backgroundColor = theme.palette.background.b3;
                borderColor = theme.palette.background.b4;
                dotColor = props.checked ? theme.palette.background.b6 : backgroundColor;
                if (props.checked) {
                    axDotVisible = true;
                }
            }
            else if (props.checked) {
                backgroundColor = theme.palette.success.main;
                borderColor = backgroundColor;
                dotColor = theme.palette.success.contrastText;
                axDotVisible = true;
            }
            return {
                backgroundColor: backgroundColor,
                alignItems: 'center',
                border: "2px solid ".concat(borderColor),
                borderRadius: radius,
                display: 'inline-flex',
                height: radius * 2,
                justifyContent: 'center',
                width: radius * 2,
                '&::before': {
                    backgroundColor: dotColor,
                    borderRadius: dotRadius,
                    // Needed for high contrast mode
                    border: axDotVisible
                        ? "".concat(dotRadius, "px solid ").concat(theme.palette.highContrastOnly.main)
                        : 'none',
                    content: '""',
                    display: 'block',
                    height: dotRadius * 2,
                    width: dotRadius * 2,
                },
            };
        },
    });
});
export var RadioIcon = function (props) {
    var classes = useStyles(props);
    return React.createElement("span", { className: classes.root, "aria-hidden": "true" });
};
//# sourceMappingURL=RadioIcon.js.map